<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="dummyLog()"
      >
        <template #rightside>
          <DropDown
            placeholder="Filter"
            :items="['Created', 'Updated', 'Deleted', 'Added', 'Removed', 'Comment']"
            :default_item="selected_filter"
            :clearable="true"
            :max_width="135"
            :light="is_light_mode(fg)"
            :background_color="bg"
            :foreground_color="fg"
            @selected="selected_filter = $event"
          />
        </template>
      </SubpageHeader>

      <div v-for="(log, index) in filtered_logs" :key="`log${index}`">
        <ClickableListItem
          :id="log.id"
          :is_selected="log.id === selected_id"
          :has_lines="true"
          :full_line="true"
          :is_first="index === 0"
          :is_completely_clickable="true"
          :margin="6"
          :background_color="bg"
          :foreground_color="fg"
          @emittedClick="selected_id = $event"
        >
          <template #front>
            <v-icon :color="fg">{{ getIconByAction(log.action) }}</v-icon>
          </template>
          <template #descriptor>
            <div class="work-package-loglist-content">
              <TText
                :text="`${log.user} ${log.date.split(' UTC')[0]}`"
                small
                :color="fg"
                align="left"
              />
              <TText
                :text="getLogText(log)"
                :color="fg"
                :size="11"
                :font_weight="400"
                align="left"
                :strikethrough="log.is_strikethrough"
              />
            </div>
          </template>
          <template #info>
            <button
              v-if="log.action === 'comment' && log.user === current_user"
              class="work-package-loglist-strikethrough"
              :style="`background-color: ${log.is_strikethrough ? `${getTranspHexColor(fg, .25)}` : ''};`"
              v-ripple
              @click.prevent.stop="toggleStrikethorugh(log)"
            >
              <v-icon :color="fg">mdi-format-strikethrough-variant</v-icon>
            </button>
          </template>
        </ClickableListItem>
      </div>
    </div>
  </div>
</template>

<script>
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      ClickableListItem,
      TText,
      DropDown,
      SubpageHeader,
    },

    mixins: [
      TColor,
    ],

    computed: {
      filtered_logs() {
        let filter = this.selected_filter;
        if(filter) {
          return this.logs.filter(function(element){
            return element.action === filter.toLowerCase();
          });
        }

        return this.logs;
      },
    },

    data: () => ({
      is_edit: true,
      current_user: 'Marco Herold',
      selected_filter: '',

      bg: '#FFC900',
      fg: '#000',
      selected_id: -1,
      // bg: '#330011',
      // fg: '#FFF',

      logs: [
        {
          id: 0,
          target: 'Work Step',
          action: 'created',
          user: 'Marco Herold',
          date: '2021-09-29 13:43:23 UTC',
          value: 'some useful information less long words to test for line break word iiiii',
          is_strikethrough: false,
        },
        {
          id: 1,
          target: 'Work Step',
          action: 'updated',
          user: 'Marco Herold',
          date: '2022-01-16 13:43:23 UTC',
          value: '',
          is_strikethrough: false,
        },
        {
          id: 2,
          target: 'Work Step',
          action: 'deleted',
          user: 'Marco Herold',
          date: '2022-01-13 13:43:23 UTC',
          value: 'this was useless',
          is_strikethrough: false,
        },
        {
          id: 3,
          target: 'Work Step',
          action: 'comment',
          user: 'Marco Herold',
          date: '2022-01-09 13:43:23 UTC',
          value: 'Heute hat es geregnet iiiiiiiiiiii :c',
          is_strikethrough: false,
        },
        {
          id: 4,
          target: 'Work Step',
          action: 'comment',
          user: 'Marco Herold',
          date: '2022-01-09 13:43:24 UTC',
          value: 'Heute hat es geregnet :c',
          is_strikethrough: true,
        },
        {
          id: 5,
          target: 'Work Step',
          action: 'comment',
          user: 'Narko Wegrollt',
          date: '2022-01-10 13:43:25 UTC',
          value: 'Heute hat war alles ausgesprochen toll ~',
          is_strikethrough: false,
        },
        {
          id: 6,
          target: 'Work Step',
          action: 'created',
          user: 'Marco Herold',
          date: '2021-11-13 13:43:23 UTC',
          value: '',
          is_strikethrough: false,
        },
        {
          id: 7,
          target: 'Work Package',
          action: 'added',
          user: 'Narko Wegrollt',
          date: '2021-11-13 11:43:23 UTC',
          value: 'User added',
          is_strikethrough: false,
        },
        {
          id: 8,
          target: 'Work Package',
          action: 'removed',
          user: 'Oktavian Sehrlangernameleider',
          date: '2021-11-13 12:43:23 UTC',
          value: 'User removed',
          is_strikethrough: false,
        },
        {
          id: 9,
          target: 'Work Step',
          action: 'comment',
          user: 'Narko Wegrollt',
          date: '2021-11-13 13:43:23 UTC',
          value: 'Wer das liest ist sehr schlau',
          is_strikethrough: true,
        },
        {
          id: 10,
          target: 'Work Step',
          action: 'created',
          user: 'Marco Herold',
          date: '2021-11-13 13:43:23 UTC',
          value: '',
          is_strikethrough: false,
        },
        {
          id: 11,
          target: 'Work Step',
          action: 'created',
          user: 'Marco Herold',
          date: '2021-11-13 13:43:23 UTC',
          value: '',
          is_strikethrough: false,
        },
      ],
    }),

    methods: {

      resetSelectedId() {
        this.selected_id = -1;
      },

      getIconByAction(action) {
        switch (action) {
          case 'created':
            return 'mdi-plus';
          case 'updated':
            return 'mdi-wrench';
          case 'comment':
            return 'mdi-comment-outline';
          case 'deleted':
            return 'mdi-delete';
          case 'added':
            return 'mdi-note-plus-outline';
          case 'removed':
            return 'mdi-note-remove-outline';
          default:
            return 'alert-circle-outline';
        }
      },

      // TODO: mutation here
      toggleStrikethorugh(log) {
        log.is_strikethrough = !log.is_strikethrough;
      },

      getLogText(log) {
        if(log.action != 'comment') {
          // EXAMPLE: Work Package created
          // EXAMPLE: Work Package created: <Name>
          return `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
        }
        else {
          // NOTE: there should never be a comment without a value (without text)
          return `Comment: ${log.value}`;
        }
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  /* .work-package-loglist-head {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  } */
  .work-package-loglist-content {
    padding-right: 8px;
  }
  .work-package-loglist-strikethrough {
    padding: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    transition: background-color 0.5s ease-in-out;
  }
</style>
